import React, { CSSProperties, ReactNode, useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import style from './Collapse.module.scss';

interface IProps {
  children: (isOpen: boolean, toggle: (isOpen: boolean) => void, options: {
    showCollapse: boolean;
    recalculateHeight: () => boolean;
  }) => ReactNode;
  maxHeight: number;
  className?: string | undefined;
  style?: CSSProperties | undefined;
}

const Collapse = ({ children, maxHeight = 0, style: propsStyles, className }: IProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [showCollapse, setShowCollapse] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    updateHeight()
  }, [isOpen, maxHeight]);

  const updateHeight = () => {
    const newValue = (contentRef.current?.scrollHeight || 0) > maxHeight;
    setShowCollapse(newValue);

    if(contentRef.current){
      contentRef.current.style.maxHeight = isOpen ? `${contentRef.current.scrollHeight || 0}px` : typeof maxHeight === "number" ? `${maxHeight}px` : '142px';
    }
    return newValue;
  }

  return (
      <div className={classnames(style.content, className)} style={propsStyles} ref={contentRef}>
        {children(isOpen, (isOpen) => setIsOpen(isOpen), {
          showCollapse,
          recalculateHeight: updateHeight
        })}
      </div>
  );
};

export default Collapse;
